import { css } from '@emotion/react'

import fontWeights from 'design-system/tokens/fontWeights'

const typographyStyles = css`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: inherit;
    font-weight: ${fontWeights.medium};
    line-height: 1.1;
    color: inherit;
  }

  h1,
  h2,
  h3 {
    margin-top: 20px;
    margin-bottom: 10px;
  }

  h4,
  h5,
  h6 {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  h1 {
    font-size: 36px;
  }

  h2 {
    font-size: 30px;
  }

  h3 {
    font-size: 24px;
  }

  h4 {
    font-size: 18px;
  }

  h5 {
    font-size: 16px;
  }

  h6 {
    font-size: 14px;
  }

  p {
    margin: 0;
    margin-bottom: 10px;
  }

  ul,
  ol {
    margin-top: 0;
    margin-bottom: 10px;

    ul,
    ol {
      margin-bottom: 0;
    }
  }

  dl {
    margin-top: 0;
    margin-bottom: 20px;
  }

  dt,
  dd {
    line-height: 1.428571429;
  }

  dt {
    font-weight: ${fontWeights.bold};
  }

  dd {
    margin-left: 0;
  }

  abbr[title] {
    border-bottom: none;
    text-decoration: underline dotted;
  }

  img {
    vertical-align: middle;
  }
`

export default typographyStyles
